/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

import { ready } from "./../core/highcharts-editor";
import { cr, ap, on, setStyle } from "./../core/highed.dom";

  let container = cr('div', 'highed-snackbar no-print'),
    title = cr('span', 'snackbar-title', ''),
    action = cr('span', 'snackbar-action', ''),
    closeNode = cr(
      'span',
      'highed-snackbar-close fa fa-times-circle',
      ''
    ),
    timeout = false,
    callback = false;

  ready(function() {
    ap(
      document.body,
      ap(container, title, action, closeNode)
    );
  });

  on(container, 'mouseover', function() {
    window.clearTimeout(timeout);
  });

  on(container, 'mouseout', function() {
    hide();
  });

  on(closeNode, 'click', function() {
    setStyle(container, {
      right: '-100%'
    });
  });

  ///////////////////////////////////////////////////////////////////////////

  function hide() {
    timeout = window.setTimeout(function() {
      setStyle(container, {
        right: '-100%'
      });
    }, 5000);
  }

  ///////////////////////////////////////////////////////////////////////////

  /**  Show a snackbar
     *   A snack bar is those info rectangles showing up on the bottom left.
     *
     *   @example
     *   snackBar('Hello world!');
     *
     *   @param stitle {string} (optional) - the snackbar title
     *   @param saction {string} (optional) - the snackbar action text
     *   @param fn {function} (optional) - the function to call when clicking the action
     */
  export default function(stitle, saction, fn) {
    title.innerHTML = stitle; // .toUpperCase();

    window.clearTimeout(timeout);

    if (saction) {
      action.innerHTML = saction.toUpperCase();
    }

    if (callback) {
      callback();
    }

    setStyle(container, {
      right: '10px'
    });

    setStyle(action, {
      display: saction ? '' : 'none'
    });

    callback = on(action, 'click', fn);

    hide();
  };
